import React from "react"
import {AiOutlineClose} from "react-icons/ai";
import HeadingSkeleton from "../../../../components/skeletons/HeadingSkeleton";

export default function PointsListSkeleton({close}) {
    return(
        <div className={'points-list'}>
            <div className={'points-list-header'}>
                <h3>
                    <span className={'heading-streak-modal'}>   <i>  <HeadingSkeleton maxWidth={100} height={15}/></i>
                      <HeadingSkeleton maxWidth={100} height={15}/>
                    </span>
                    <span className={'close-btn'} onClick={()=>{close(false)}}><AiOutlineClose /> </span>
                </h3>
            </div>
            <div className={'points-list-details'}>
                <ul>
                    {
                        [1,2,4,5,6,7].map((item,index)=>{
                            return(
                                <li key={index}>
                                    <h4>
                                        <HeadingSkeleton maxWidth={200} height={20}/>
                                    </h4>
                                    <ul>
                                        {
                                            [1,2,3,4,5].map((it,ind)=>{
                                                return(
                                                    <li key={ind}>
                                                        <p>  <HeadingSkeleton maxWidth={300} height={15}/> <span>  <HeadingSkeleton maxWidth={30} height={15}/></span></p>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
}